<div class="modal" id="loadTemplate" tabindex="-1">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				Wybierz szablon
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div
					class="btn btn-primary me-4"
					*ngFor="let item of data"
					(click)="select(item)"
					data-bs-dismiss="modal"
				>
					{{ item.name }}
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>
			</div>
		</div>
	</div>
</div>
